import type { FiltersQuery } from '@upbeat/shared';
import { getToken } from '../auth/keycloak';

export const API_BASE = import.meta.env.VITE_API_BASE ?? '/api';

export class HttpError extends Error {
  constructor(public readonly status: number, message: string) {
    super(message);
    this.name = 'HttpError';
  }
}

export function toSearch(q: Record<string, unknown>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === null || v === '') continue;
    sp.set(k, String(v));
  }
  return sp.toString();
}

export async function getJson<T>(path: string, q?: Record<string, unknown> | FiltersQuery, signal?: AbortSignal): Promise<T> {
  const url = q ? `${API_BASE}/${path}?${toSearch(q)}` : `${API_BASE}/${path}`;
  const token = await getToken();
  const headers: Record<string, string> = { accept: 'application/json' };
  if (token) {
    headers['authorization'] = `Bearer ${token}`;
  }
  const res = await fetch(url, { signal, headers });
  if (!res.ok) {
    let message = res.statusText;
    try {
      const body = (await res.json()) as { message?: string };
      if (body.message) message = body.message;
    } catch { /* not json */ }
    throw new HttpError(res.status, message);
  }
  return (await res.json()) as T;
}
